<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    created() {
        document.title = process.env.VUE_APP_TITLE;
    },
};
</script>

<style lang="scss">
  * {
      padding: 0;
      margin: 0;
      box-sizing: border-box;
  }
  html {
      font-size: var(--global-font-size);
      height: 100%;
  }
  body {
      height: 100%;
  }
  #app {
      min-height: 100%;
      font-family: var(--global-font-family);
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      color: var(--global-font-color) !important;
      .main-content {
          padding-top: var(--global-gutter-size);
          padding-bottom: var(--global-gutter-size);
      }
      h1 {
          font-size: var(--global-primary-title-size);
      }
      h2 {
          font-size: var(--global-secondary-title-size);
          font-weight: 600;
      }
  }
  #nprogress .bar {
      background-color: var(--global-primary-brand) !important;
      height: 3px !important;
  }

  #nprogress .spinner-icon {
      border-top-color: var(--global-primary-brand) !important;
      border-left-color: var(--global-primary-brand) !important;
  }

  #nprogress .peg {
      box-shadow: 0 0 10px var(--global-primary-brand),
          0 0 5px var(--global-primary-brand) !important;
  }
</style>
